import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Sharing from '../Common/Sharing'

class SharingDienstregeling extends Component {
  static propTypes = {
    config: PropTypes.object,
  }

  render() {
    const {
      print,
      mail,
      whatsapp
    } = this.props.config

    if (print) {
      print.buttonText = this.applyInfoToText(print.buttonText)
    }
    if (mail) {
      mail.buttonText = this.applyInfoToText(mail.buttonText)
      mail.subjectText = this.applyInfoToText(mail.subjectText)
      mail.messageText = this.applyInfoToText(mail.messageText, true)
    }
    if (whatsapp) {
      whatsapp.buttonText = this.applyInfoToText(whatsapp.buttonText)
      whatsapp.messageText = this.applyInfoToText(whatsapp.messageText, true)
    }


    return (
      <Sharing
        className="dienstregeling__shares"
        print={print}
        mail={mail}
        whatsapp={whatsapp}
       />
    )
  }

  applyInfoToText(text, encodeLink = false) {
    const {
      lineNumber,
      name
    } = this.props
    const link = window.location 
    return (text || '').replace(/{lineNumber}/g, lineNumber).replace(/{name}/g, name).replace(/{link}/g, (encodeLink) ? encodeURIComponent(link) : link)
  }
}


export default connect(
  state => {
    const {
      lineNumber,
      name
    } = state.dienstregeling

    return {
      lineNumber: lineNumber || '?',
      name: name || '?',
    }
  },
  {}
)(SharingDienstregeling)



// WEBPACK FOOTER //
// ./src/components/Dienstregeling/Sharing.js